export const useStyles = theme => ({
  dashboardRoot: {
    padding: '2em 5em',
    backgroundColor: '#0D6A41',
    height: '100vh',
    [theme.breakpoints.down('md')]: {
      padding: '1em',
    },
  },
  dashboardContainer: {
    marginTop: '8%',
    display: 'flex',
    alignItems: 'baseline',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      padding: '10px',
      height: '92%',
    },
  },
  dashboardLeftContainer: {
    width: '70%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '52%',
    },
  },
  dashboardRightContainer: {
    width: '30%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '32%',
    },
  },
  dashboardHeader: {
    font: 'normal normal 900 98px/119px Maax-Black',
    color: '#fff',
    [theme.breakpoints.down('md')]: {
      font: 'normal normal 900 40px/50px Maax-Black',
    },
  },
  dashboardSubHeader: {
    font: 'normal normal 900 60px/72px Maax-Black',
    color: '#F0B310',
    [theme.breakpoints.down('md')]: {
      font: 'normal normal 900 30px/50px Maax-Black',
    },
  },
  dashboardDetails: {
    color: '#fff',
    fontFamily: 'Maax-Medium',
  },
  chapterContainer: {
    justifyContent: 'space-between',
    width: '50%',
    marginTop: '20px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  chapterHolder: {
    //backgroundColor: '#fff',
    textAlign: 'center',
    padding: '20px',
    listStyleType: 'none',
    borderRight: '1px solid',
    [theme.breakpoints.down('md')]: {
      padding: '10px',
    },
    marginRight: '5px',
  },
  chapterName: {
    color: '#F0B310 !important',
    font: 'normal normal medium 18px/24px Maax-Medium',
  },
  chapterDate: {
    font: 'normal normal medium 18px/24px Maax-Regular',
  },
  submitButtonStyle: {},
});
